import React from 'react'

const MultiplicativeCipherTheory = () => {
    return (
        <div>
            <ul>
                <li>
                    <p>
                        A multiplicative cipher is a type of cipher that comes under a monoalphabetic cipher, in which each letter that is present in the plaintext is replaced by a corresponding letter of the ciphertext, according to a fixed multiplication key.
                    </p>
                </li>
                <li>
                    <p>
                        The basic task behind the multiplicative cipher is to use a large prime number as a multiplication key, and then use the modular arithmetic of the integers modulo, the key to encode and decode the plaintext. 
                    </p>
                </li>
                <li>
                    <p>
                        The encryption process is done by multiplying the numerical value of each letter in the plaintext by the key and then taking the result modulo the key. For example, if the key is 7 and the plaintext letter is ‘s’, the numerical value of ‘s’ is 18, and so the ciphertext letter is (18*7) mod 26 = 22. So the cipher text symbol will be ‘w’ for the letter ‘a in this case.
                    </p>
                </li>
                <li>
                    <p>
                        The decryption process is simply the reverse of the encryption process, i.e., by dividing the numerical value of each letter in the ciphertext by key and then taking the result modulo of the key.
                    </p>
                </li>
                <li>
                    <p>
                        One of the main advantages of the multiplicative cipher is its simplicity i.e. It is easy to implement and easy to understand, and it does not require any large amount of computational power. It is suitable for small-scale applications but not recommended for practical purposes.
                    </p>
                </li>
                <li>
                    <p style={{ fontWeight: "bold", color: "blue" }}>
                        How to find the Modulo Multiplicative Inverse?
                    </p>
                    <p>Suppose you want to find the Modulo Multiplicative Inverse of "a" when modulo is "m", then it "b" is the Modulo Multiplicative Inverse of "a" if it satisfies the following condition :</p>
                    <p style={{ fontWeight: "bold", color: "red" }}>(a * b) mod m = 1</p>
                    <p style={{ fontWeight: "bold" }}>Example :-</p> 
                    <p>
                    <p>Find modulo multiplicative inverse of "3" when modulo is "26".</p>
                    <p>- (3 * 9) mod 26 = 1</p>
                    <p>- Hence, modulo multiplicative inverse of "3" is "9"</p>
                    </p>
                </li>
            </ul>
        </div>
    )
}

export default MultiplicativeCipherTheory